module.exports = __webpack_public_path__ + "img/porte.75ad9fa.svg";